// Nerva Animations (Lottie JSON files and SVGs)
export const animations = {
  visceralHypnersensitivity: '/images/visceralHypnersensitivity.json',
  gutBrainConnection: '/images/gutBrainConnection.json',
  brainGutColour: '/images/brainGutColour.json',
  gutBrainTick: '/images/gutBrainTick.json',
  referralChart: '/images/referralChart.json',
  brainGutCommunication: '/images/brainGutCommunication.json',
  nervaBackgroundMobile: '/images/nerva-background.svg',
  nervaBackgroundDesktop: '/images/nervaBackgroundDesktop.json',
};
